import styled from '@emotion/styled';

const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  padding: '1.6rem 0 4rem 0',
});

export default Container;
